// extracted by mini-css-extract-plugin
module.exports = {"phrase":"homePhrase_phrase__1LJnb","phraseTranslation":"homePhrase_phraseTranslation__2uNa1"};